import { GsFormSchema } from 'libs/shared/src/components';
import { BASIC_SCHEMA_FIELDS, borderRadiusSchemaFields, Mode, SWIPER_SCHEMA_FIELDS } from '../basics';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the team-member-detail component form.
 * Defines the fields to display for the form.
 */
export const TEAM_MEMBER_DETAIL_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    {
      // Used to always show the swiper/items settings because this component just has a swiper-mode
      formControlName: 'mode',
      type: 'control',
      default: Mode.SLIDER
    },
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...SWIPER_SCHEMA_FIELDS,
    {
      formControlName: 'isPhoneVisible',
      type: 'checkbox',
      label: 'components.teamMemberDetail.schema.phoneNumber',
      groupingName: 'components.teamMemberDetail.schema.contactInfos',
      default: true
    },
    {
      formControlName: 'isEmailVisible',
      type: 'checkbox',
      label: 'components.teamMemberDetail.schema.email',
      groupingName: 'components.teamMemberDetail.schema.contactInfos',
      default: true
    },
    {
      formControlName: 'isMobileVisible',
      type: 'checkbox',
      label: 'components.teamMemberDetail.schema.mobileNumber',
      groupingName: 'components.teamMemberDetail.schema.contactInfos',
      default: true
    },
    {
      formControlName: 'isLocationVisible',
      type: 'checkbox',
      label: 'components.teamMemberDetail.schema.location',
      groupingName: 'components.teamMemberDetail.schema.contactInfos',
      default: true
    },
    {
      formControlName: 'isFunctionVisible',
      type: 'checkbox',
      label: 'components.teamMemberDetail.schema.function',
      groupingName: 'components.teamMemberDetail.schema.contactInfos',
      default: true
    },
    {
      formControlName: 'isCategoriesVisible',
      type: 'checkbox',
      label: 'components.teamMemberDetail.schema.categoriesAndAreas',
      groupingName: 'components.teamMemberDetail.schema.contactInfos',
      default: true
    },
    {
      formControlName: 'isDescriptionVisible',
      type: 'checkbox',
      label: 'components.teamMemberDetail.schema.description',
      groupingName: 'components.teamMemberDetail.schema.contactInfos',
      default: true
    },
    {
      formControlName: 'isWorkingHoursVisible',
      type: 'checkbox',
      label: 'components.teamMemberDetail.schema.workingHours',
      groupingName: 'components.teamMemberDetail.schema.contactInfos',
      default: true
    },
    {
      formControlName: 'categoriesHeader',
      type: 'text',
      label: 'components.teamMemberDetail.schema.categoriesAndAreas',
      placeholder: 'components.teamMemberDetail.schema.headerPlaceholder',
      inputType: 'text',
      default: ''
    },
    {
      formControlName: 'workingHoursHeader',
      type: 'text',
      label: 'components.teamMemberDetail.schema.workingHours',
      placeholder: 'components.teamMemberDetail.schema.headerPlaceholder',
      inputType: 'text',
      default: ''
    },
    {
      formControlName: 'isAppointmentButtonVisible',
      type: 'checkbox',
      label: 'components.teamMemberDetail.schema.showAppointmentButton',
      default: false
    },
    ...borderRadiusSchemaFields('', undefined, false, undefined, 'schema.imageRadius')
  ]
};
